// The label options a customer can choose per weaving field (weaving plan WS10) -
// from the customer-ticket synonyms in the data model's Appendix A. Every synonym
// here must have a case in TmsWebTranslationService.translateFieldLabel so a
// chosen label still translates.
export const FieldLabelSynonyms: Record<string, string[]> = {
  QualityKey: ['Quality', 'Pattern', 'Product Quality'],
  DesignKey: ['Design', 'Range'],
  ColourwayCode: ['Colourway', 'Shade'],
  Sley: ['Sett', 'E.P.I', 'Setting', 'Sley'],
  GroundEnds: ['Ends', 'Ground Ends', 'Grd'],
  PicksPerInch: ['Picks', 'Req. Px', 'Shots'],
  WarpCount: ['Count', 'Grist'],
  ReedWidth: ['Reed Width', 'Width', 'Loom Width'],
  ExtrasPerRepeat: ['Extras', 'AS'],
};
